module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-std",
    attrs: {
      "id": "menu-std",
      "name": "menu-std"
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Components")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-panel"
  }, [_c('li', {
    staticClass: "menu",
    class: {
      '-active': _vm.exButtonActive
    },
    on: {
      "click": function($event) {
        _vm.togglePage('exButtonActive')
      }
    }
  }, [_vm._v("Button")]), _vm._v(" "), _c('li', {
    staticClass: "menu",
    class: {
      '-active': _vm.exButtonGroupActive
    },
    on: {
      "click": function($event) {
        _vm.togglePage('exButtonGroupActive')
      }
    }
  }, [_vm._v("Button Group")]), _vm._v(" "), _c('li', {
    staticClass: "menu",
    class: {
      '-active': _vm.exCollapseActive
    },
    on: {
      "click": function($event) {
        _vm.togglePage('exCollapseActive')
      }
    }
  }, [_vm._v("Collapse")]), _vm._v(" "), _c('li', {
    staticClass: "menu",
    class: {
      '-active': _vm.exDropdownActive
    },
    on: {
      "click": function($event) {
        _vm.togglePage('exDropdownActive')
      }
    }
  }, [_vm._v("Dropdown Menu")]), _vm._v(" "), _c('li', {
    staticClass: "menu",
    class: {
      '-active': _vm.exCheckboxActive
    },
    on: {
      "click": function($event) {
        _vm.togglePage('exCheckboxActive')
      }
    }
  }, [_vm._v("Form Checkbox")]), _vm._v(" "), _c('li', {
    staticClass: "menu",
    class: {
      '-active': _vm.exInputActive
    },
    on: {
      "click": function($event) {
        _vm.togglePage('exInputActive')
      }
    }
  }, [_vm._v("Form Input")]), _vm._v(" "), _c('li', {
    staticClass: "menu",
    class: {
      '-active': _vm.exRadioActive
    },
    on: {
      "click": function($event) {
        _vm.togglePage('exRadioActive')
      }
    }
  }, [_vm._v("Form Radio")]), _vm._v(" "), _c('li', {
    staticClass: "menu",
    class: {
      '-active': _vm.exSelectActive
    },
    on: {
      "click": function($event) {
        _vm.togglePage('exSelectActive')
      }
    }
  }, [_vm._v("Form Select")]), _vm._v(" "), _c('li', {
    staticClass: "menu",
    class: {
      '-active': _vm.exModalActive
    },
    on: {
      "click": function($event) {
        _vm.togglePage('exModalActive')
      }
    }
  }, [_vm._v("Modal")]), _vm._v(" "), _c('li', {
    staticClass: "menu",
    class: {
      '-active': _vm.exTabActive
    },
    on: {
      "click": function($event) {
        _vm.togglePage('exTabActive')
      }
    }
  }, [_vm._v("Tab")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-048c57bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/styleGuide/menu.vue
// module id = 3512
// module chunks = 1